import { render } from "./App.vue?vue&type=template&id=4bc425c9&scoped=true&ts=true"
import script from "./App.ts?vue&type=script&lang=ts&external"
export * from "./App.ts?vue&type=script&lang=ts&external"

import "./css/style.css?vue&type=style&index=0&lang=css&external"
import "./css/tooltip.css?vue&type=style&index=1&lang=css&external"
import "./css/app.css?vue&type=style&index=2&lang=css&external"
import "./css/booster-open.css?vue&type=style&index=3&lang=css&external"
import "./css/chat.css?vue&type=style&index=4&lang=css&external"
import "./App.vue?vue&type=style&index=5&id=4bc425c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc425c9"]])

export default __exports__